export default defineNuxtRouteMiddleware((to) => {
    if (to.path === '/cp') {
        navigateTo(`${useRuntimeConfig().public.statamicUrl}/cp/dashboard`, { external: true })
    }
})
